module.exports = __webpack_public_path__ + "static/logo-98479af9788fe065cf700a357b90c28f.png";